import AOS from "aos";
import "aos/dist/aos.css";
import { useEffect, useState } from "react";
import Select from "react-select";
import { Currency_Converter_API_URL } from "../../Process";
import ContactFooter from "./ContactusFooter";
import "./CurrencyConverter.css";
import Marquee from "./Marquee";

const CurrencyConverterPage = () => {
  const [currencyData, setCurrencyData] = useState([]);

  const [cityData, setCityData] = useState([]);
  const [selectedCity, setSelectedCity] = useState();

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, []);

  useEffect(() => {
    AOS.init({
      duration: 1000, // animation duration
      once: true, // animate only once
      easing: "ease-in-out",
      offset: 120,
    });
  }, []);

  useEffect(() => {
    // 1️⃣ Call API immediately on mount
    fetchData();
    fetchCityData();
    // 2️⃣ Call API every 1 minute
    const intervalId = setInterval(() => {
      fetchData();
    }, 60 * 1000); // 1 minute

    // 3️⃣ Cleanup on unmount
    return () => clearInterval(intervalId);
  }, []);

  useEffect(() => {
    if (cityData.length > 0) {
      const defaultCity = cityData.find((ele) => ele.Location?.toLowerCase() === "mumbai");

      // Map it to react-select option shape
      if (defaultCity) {
        setSelectedCity({ label: defaultCity.Location, value: defaultCity.LocationID });
      }
    }
  }, [cityData]);

  const fetchData = async () => {
    try {
      const response = await fetch(`${Currency_Converter_API_URL}currencyMaster/getCurrencyData`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const tempData = await response.json();
      setCurrencyData(tempData?.data);

      // Let React finish DOM updates, then refresh AOS
      setTimeout(() => {
        AOS.refresh();
      }, 100);
    } catch (error) {
      console.error("API error:", error);
    }
  };

  const fetchCityData = async () => {
    try {
      const response = await fetch(`${Currency_Converter_API_URL}location/getLocation`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const tempData = await response.json();
      setCityData(tempData?.data);
    } catch (error) {
      console.error("API error:", error);
    }
  };

  console.log("dsfskldfjksdfjdskfa", selectedCity);

  return (
    <>
      {/* <div className="preloader js-preloader">
        <div className="loader loader-inner-1">
          <div className="loader loader-inner-2">
            <div className="loader loader-inner-3"></div>
          </div>
        </div>
      </div> */}
      {/* <div class="switch-theme-mode">
        <label id="switch" class="switch">
          <input type="checkbox" onchange="toggleTheme()" id="slider" />
          <span class="slider round"></span>
        </label>
      </div> */}

      {/* <div className="page-wrapper"> */}
      <div
        style={{
          minHeight: "100vh",
          position: "relative",
          background: `
            linear-gradient(135deg, #eef2f7, #e2e8f0),
            linear-gradient(
              120deg,
              rgba(56,189,248,0.25),
              rgba(139,92,246,0.22),
              rgba(20,184,166,0.25)
            )
          `,
          backgroundBlendMode: "overlay",
        }}
      >
        {/* Your existing page content */}
        <div className="content-layer ">
          <header className="header-wrap style1 mb-5">
            <div
              className="header-bottom shadow-sm"
              style={{
                position: "relative",
                width: "100vw", // ensure full width
                overflow: "hidden", // prevents overflow
                background: `
                  linear-gradient(135deg, #eef2f7, #e2e8f0),
                  linear-gradient(
                    120deg,
                    rgba(56,189,248,0.25),
                    rgba(139,92,246,0.22),
                    rgba(20,184,166,0.25)
                  )
                `,
                backgroundBlendMode: "overlay",
              }}
            >
              <div className="container d-flex justify-content-between align-items-center py-3 px-0">
                <a className="navbar-brand d-flex align-items-center" href="/">
                  <img className="logo-light" src="/media/projectLogo.png" alt="Project Logo" style={{ height: 60, objectFit: "contain" }} />
                  <span className="ms-2 fw-bold text-dark" style={{ fontSize: "25px" }}>
                    BookYourForex
                  </span>
                </a>

                {/* <button
                  className="navbar-toggler d-lg-none border-0 bg-transparent"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#navbarSupportedContent"
                  aria-controls="navbarSupportedContent"
                  aria-expanded="false"
                  aria-label="Toggle navigation"
                >
                  <i className="ri-menu-line fs-3"></i>
                </button> */}
              </div>
            </div>
          </header>
          {/* <div className="bg-gray py-2 text-white shadow-sm"> */}
          <Marquee speed={15}>
            <span>🔥 FAST & HASSLE FREE</span>
            <span>💱 Secure Money Exchange</span>
            <span>🌍 Global Coverage</span>
            <span>⚡ Instant Transfers</span>
          </Marquee>
          {/* </div> */}
          <section className="exchange-table-wrap   pt-30">
            <div className="container">
              <div className="row">
                <div className="col-xl-6 offset-xl-3 col-lg-8 offset-lg-2">
                  <div className="section-title style1 text-center mb-10">
                    <span>LIVE EXCHANGE RATES</span>
                    <h2>Exchange Money Across The World In Real Time With Lowest Fees</h2>
                  </div>
                  <div className="d-flex align-items-center exchange-select mb-3 gap-3" style={{ flexWrap: "wrap" }}>
                    <label htmlFor="country-select" className="mb-0 fw-bold">
                      Select City:
                    </label>

                    <div style={{ minWidth: 200, flex: 1 }}>
                      <Select
                        id="country-select"
                        options={cityData?.map((city) => {
                          return {
                            label: city?.Location,
                            value: city?.LocationID,
                          };
                        })}
                        value={selectedCity}
                        onChange={setSelectedCity} // ✅ update state
                        onMenuOpen={() => console.log("Menu Opened")}
                        onMenuClose={() => console.log("Menu Closed")}
                        placeholder="Choose a city..."
                        isSearchable
                        styles={{
                          control: (base) => ({
                            ...base,
                            borderRadius: 6,
                            minHeight: 40,
                            boxShadow: "none",
                            borderColor: "#ced4da",
                            "&:hover": { borderColor: "#80bdff" },
                          }),
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="exchange-table">
                {/* <div className="table-responsive"> */}
                <table className="table table-bordered table-hover text-center align-middle">
                  <thead>
                    <tr>
                      <th scope="col" style={{ textAlign: "center" }}>
                        Country
                      </th>
                      <th scope="col">Buy Currency</th>
                      <th scope="col">Sell Currency</th>
                      <th scope="col" style={{ textAlign: "center" }}>
                        Card
                      </th>
                      {/* <th scope="col">
                      <span className="action">
                        <i className="ri-edit-line"></i>Edit
                      </span>
                    </th> */}
                    </tr>
                  </thead>
                  <tbody>
                    {currencyData?.length === 0 ? (
                      <tr>
                        <td colSpan={7} className="text-center py-5">
                          <div className="no-data-card">
                            <div className="no-data-icon">📄</div>
                            <h5>No Records Found</h5>
                            <p>There is no currency data available for the selected criteria.</p>
                          </div>
                        </td>
                      </tr>
                    ) : (
                      currencyData?.map((ele) => {
                        return (
                          <tr>
                            {/* <td className="text-center">
                              <div>{ele?.Country}</div>
                            </td> */}
                            <td style={{ textAlign: "center" }}>
                              <div className="fw-bold fs-6">{ele?.Currency}</div>
                              <div className="small text-muted">{ele?.Country}</div>
                            </td>
                            <td className="text-center">
                              <div>{ele?.BuyRate}</div>
                            </td>
                            <td className="text-center">
                              <div>{ele?.SellRate}</div>
                            </td>
                            <td className="text-center">
                              <div>{ele?.Card}</div>
                            </td>
                          </tr>
                        );
                      })
                    )}
                  </tbody>
                </table>
                <style jsx>{`
                  .table-bordered th,
                  .table-bordered td {
                    border: 1px solid #0d9488; /* change this to your desired color */
                  }
                  .table-hover tbody tr:hover {
                    background-color: #e0f2f1; /* subtle hover highlight */
                    transition: background-color 0.3s ease;
                  }
                  thead.table-light th {
                    background-color: #f0fdfa;
                    font-weight: 600;
                    color: #0f172a;
                    border-bottom: 2px solid #0d9488; /* match border color */
                  }
                `}</style>
                {/* </div> */}
              </div>
              <div className="d-flex justify-content-center mt-4">
                <button
                  className="btn enquiry-btn px-5 py-2"
                  onClick={() => {
                    document.getElementById("contact-us")?.scrollIntoView({ behavior: "smooth" });
                  }}
                >
                  Enquiry Now
                </button>
              </div>

              {/* <div className="row align-items-center">
                <div className="col-sm-6">
                  <button type="button" className="add-currency">
                    <span>
                      <i className="ri-add-circle-line"></i>
                    </span>
                    Add Currency
                  </button>
                </div>
                <div className="col-sm-6 text-sm-end">
                  <p className="update-status">Last Updated Jan 20, 2024</p>
                </div>
              </div> */}
            </div>
          </section>
          {/* <section className="hero-wrap style1"> */}
          <section className="hero-wrap style1 ">
            <div className="container">
              <img src="assets/img/hero/hero-shape-1.png" alt="Image" className="hero-shape-one animationFramesTwo" />
              <img src="assets/img/hero/hero-shape-2.png" alt="Image" className="hero-shape-two moveHorizontal" />
              <img src="assets/img/hero/hero-shape-3.png" alt="Image" className="hero-shape-three bounce" />
              <div className="row align-items-center">
                <div className="col-lg-5">
                  <div className="hero-content" data-speed="0.06" data-revert="true">
                    <span data-aos="fade-up" data-aos-duration="1000" data-aos-delay="200">
                      FAST &amp; HASTLE FREE
                    </span>
                    <h1 data-aos="fade-up" data-aos-duration="1000" data-aos-delay="300">
                      The Most Powerful Money Exchange Service In The World
                    </h1>
                    <p data-aos="fade-up" data-aos-duration="1000" data-aos-delay="400">
                      It is a long established fact that a reader will be distracted by the reale he point of using Lorem Ipsum is that it has a more-or-less normal valid equity.
                    </p>
                    {/* <a href="contact.html" className="btn style1" data-aos="fade-up" data-aos-duration="1000" data-aos-delay="500">
                      CONTACT US<i className="ri-arrow-right-s-line"></i>
                    </a> */}
                  </div>
                </div>
                <div className="col-lg-7">
                  <div className="hero-currency-convert" data-aos="fade-up" data-aos-duration="1000" data-aos-delay="400">
                    <div className="hero-currency-img" data-aos="fade-up" data-aos-duration="1000" data-aos-delay="300">
                      <img src="assets/img/hero/hero-img-1.png" alt="Image" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

          {/* <section className="about-wrap style1 ptb-100"> */}
          <section className="about-wrap style1 ptb-100">
            <div className="container">
              <div className="row gx-5 align-items-center">
                <div className="col-lg-6">
                  <div className="row">
                    <div className="col-6 about-img-wrap" data-aos="fade-up" data-aos-duration="1000" data-aos-delay="200">
                      <img src="assets/img/about/about-shape-4.png" alt="Image" className="about-shape-one bounce" />
                      <div className="about-img">
                        <img src="assets/img/about/about-img-1.jpg" alt="Image" />
                      </div>
                      <div className="about-img">
                        <img src="assets/img/about/about-img-2.jpg" alt="Image" />
                      </div>
                    </div>
                    <div className="col-6 about-img-wrap lgm-70" data-aos="fade-down" data-aos-duration="1000" data-aos-delay="300">
                      <img src="assets/img/shape-1.png" alt="Image" className="about-shape-two moveHorizontal" />
                      <div className="about-img">
                        <img src="assets/img/about/about-img-3.jpg" alt="Image" />
                      </div>
                      <div className="about-img">
                        <img src="assets/img/about/about-img-4.jpg" alt="Image" />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-lg-6" data-aos="fade-left" data-aos-duration="1000" data-aos-delay="200">
                  <div className="about-content">
                    <div className="content-title style1">
                      <span>ABOUT US</span>
                      <h2>Transfer &amp; Exchange Your Money Anytime Inthis World</h2>
                      <p>
                        Best Strategic planning dolor sit amet consectetur adipiscing elit. Scel erus isque ametus odio velit auctor nam elit nulla eget sodales dui pulvinar dolor
                        strategic planning dolor sit sectetur morethe.
                      </p>
                    </div>
                    <div className="feature-item-wrap">
                      <div className="feature-item">
                        <div className="feature-icon">
                          <i className="flaticon-clicking"></i>
                        </div>
                        <div className="feature-text">
                          <h3>Powerful Mobile &amp; Online App</h3>
                          <p>Vestibulum ac diam sit amet quam vehicula elemen tum sed sit amet dui praesent sapien pellen tesque .</p>
                        </div>
                      </div>
                      <div className="feature-item">
                        <div className="feature-icon">
                          <i className="flaticon-alarm"></i>
                        </div>
                        <div className="feature-text">
                          <h3>Brings More Transperency &amp; Speed</h3>
                          <p>Vestibulum ac diam sit amet quam vehicula elemen tum sed sit amet dui praesent sapien pellen tesque.</p>
                        </div>
                      </div>
                      <div className="feature-item">
                        <div className="feature-icon">
                          <i className="flaticon-setting"></i>
                        </div>
                        <div className="feature-text">
                          <h3>Special For Multiple User Capabilities</h3>
                          <p>Vestibulum ac diam sit amet quam vehicula elemen tum sed sit amet dui praesent sapien pellen tesque.</p>
                        </div>
                      </div>
                    </div>
                    {/* <a href="about.html" className="btn style1">
                      READ MORE
                      <i className="ri-arrow-right-s-line"></i>
                    </a> */}
                  </div>
                </div>
              </div>
            </div>
          </section>

          {/* <section className="wh-wrap style1 ptb-100 bg-whisper"> */}
          <section className="wh-wrap style1 ptb-20 bg-whisper">
            <div className="container">
              <div className="row gx-5 align-items-center">
                <div className="col-lg-6 order-lg-1 order-md-2 order-2" data-aos="fade-right" data-aos-duration="1000" data-aos-delay="200">
                  <div className="wh-content">
                    <div className="content-title style1">
                      <span>CUEX CURRENCY TOOLS</span>
                      <h2>We Provide Currency Exchange Services World Wide</h2>
                      <p>
                        Best Strategic planning dolor sit amet consectetur adipiscing elit. Scel erus isque ametus odio velit auctor nam elit nulla eget sodales dui pulvinar dolor
                        strategic planning dolor sit sectetur morethe.
                      </p>
                    </div>
                    <div className="feature-item-wrap">
                      <div className="feature-item">
                        <div className="feature-icon">
                          <i className="flaticon-tick"></i>
                        </div>
                        <div className="feature-text">
                          <h3>Historical Currency Rates</h3>
                          <p>Vestibulum ac diam sit amet quam vehicula elemen tum sed sit amet dui praesent sapien pellen tesque .</p>
                        </div>
                      </div>
                      <div className="feature-item">
                        <div className="feature-icon">
                          <i className="flaticon-tick"></i>
                        </div>
                        <div className="feature-text">
                          <h3>Travel Expense Calculator</h3>
                          <p>Vestibulum ac diam sit amet quam vehicula elemen tum sed sit amet dui praesent sapien pellen tesque.</p>
                        </div>
                      </div>
                      <div className="feature-item">
                        <div className="feature-icon">
                          <i className="flaticon-tick"></i>
                        </div>
                        <div className="feature-text">
                          <h3>Currency Email Updates</h3>
                          <p>Vestibulum ac diam sit amet quam vehicula elemen tum sed sit amet dui praesent sapien pellen tesque.</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-lg-6 order-lg-2 order-md-1 order-1" data-aos="fade-left" data-aos-duration="1000" data-aos-delay="200">
                  <div className="row align-items-end">
                    <div className="col-6 wh-img-wrap">
                      <div className="wh-img">
                        <img src="assets/img/shape-7.png" alt="Image" className="wh-shape-one bounce" />
                        <img src="assets/img/why-choose-us/wh-img-1.jpg" alt="Image" />
                      </div>
                    </div>
                    <div className="col-6 wh-img-wrap">
                      <img src="assets/img/shape-8.png" alt="Image" className="wh-shape-two moveHorizontal" />
                      <div className="wh-img">
                        <img src="assets/img/why-choose-us/wh-img-2.jpg" alt="Image" />
                      </div>
                      <div className="wh-img">
                        <img src="assets/img/why-choose-us/wh-img-3.jpg" alt="Image" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <section className="currency-wrap pt-20 pb-75">
            <div className="container">
              <div className="row">
                <div className="col-xl-6 offset-xl-3 col-lg-8 offset-lg-2">
                  <div className="section-title style1 text-center mb-40">
                    <span>CURRENCY PROFILE</span>
                    <h2>Get These Local Account Details Just Like Pay A Local</h2>
                  </div>
                </div>
              </div>
              <div className="row justify-content-center">
                <div className="col-xl-4 col-lg-6 col-md-6">
                  <div className="currency-card">
                    <div className="currency-flag">
                      <img src="assets/img/flag/usa.png" alt="Image" />
                    </div>
                    <div className="currency-info">
                      <h3>USD - US Dollar</h3>
                      <p>Adipiscing eliId nque diraam nim etrous porta vierra dolore.</p>
                    </div>
                  </div>
                </div>
                <div className="col-xl-4 col-lg-6 col-md-6">
                  <div className="currency-card">
                    <div className="currency-flag">
                      <img src="assets/img/flag/eu.png" alt="Image" />
                    </div>
                    <div className="currency-info">
                      <h3>EUR - Euro</h3>
                      <p>Adipiscing eliId nque diraam nim etrous porta vierra dolore.</p>
                    </div>
                  </div>
                </div>
                <div className="col-xl-4 col-lg-6 col-md-6">
                  <div className="currency-card">
                    <div className="currency-flag">
                      <img src="assets/img/flag/uk.png" alt="Image" />
                    </div>
                    <div className="currency-info">
                      <h3>GBP - British Pound</h3>
                      <p>Adipiscing eliId nque diraam nim etrous porta vierra dolore.</p>
                    </div>
                  </div>
                </div>
                <div className="col-xl-4 col-lg-6 col-md-6">
                  <div className="currency-card">
                    <div className="currency-flag">
                      <img src="assets/img/flag/canada.png" alt="Image" />
                    </div>
                    <div className="currency-info">
                      <h3>CAD - Canadian Dollar</h3>
                      <p>Adipiscing eliId nque diraam nim etrous porta vierra dolore.</p>
                    </div>
                  </div>
                </div>
                <div className="col-xl-4 col-lg-6 col-md-6">
                  <div className="currency-card">
                    <div className="currency-flag">
                      <img src="assets/img/flag/australia.png" alt="Image" />
                    </div>
                    <div className="currency-info">
                      <h3>AUD - Aus Dollar</h3>
                      <p>Adipiscing eliId nque diraam nim etrous porta vierra dolore.</p>
                    </div>
                  </div>
                </div>
                <div className="col-xl-4 col-lg-6 col-md-6">
                  <div className="currency-card">
                    <div className="currency-flag">
                      <img src="assets/img/flag/japan.png" alt="Image" />
                    </div>
                    <div className="currency-info">
                      <h3>JPY - Japaneese Yen</h3>
                      <p>Adipiscing eliId nque diraam nim etrous porta vierra dolore.</p>
                    </div>
                  </div>
                </div>
                <div className="col-xl-4 col-lg-6 col-md-6">
                  <div className="currency-card">
                    <div className="currency-flag">
                      <img src="assets/img/flag/india.png" alt="Image" />
                    </div>
                    <div className="currency-info">
                      <h3>INR - Indian Rupee</h3>
                      <p>Adipiscing eliId nque diraam nim etrous porta vierra dolore.</p>
                    </div>
                  </div>
                </div>
                <div className="col-xl-4 col-lg-6 col-md-6">
                  <div className="currency-card">
                    <div className="currency-flag">
                      <img src="assets/img/flag/newzland.png" alt="Image" />
                    </div>
                    <div className="currency-info">
                      <h3>NZD - NZ Dollar</h3>
                      <p>Adipiscing eliId nque diraam nim etrous porta vierra dolore.</p>
                    </div>
                  </div>
                </div>
                <div className="col-xl-4 col-lg-6 col-md-6">
                  <div className="currency-card">
                    <div className="currency-flag">
                      <img src="assets/img/flag/france.png" alt="Image" />
                    </div>
                    <div className="currency-info">
                      <h3>CHF - Swiss Franc</h3>
                      <p>Adipiscing eliId nque diraam nim etrous porta vierra dolore.</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <ContactFooter />

          {/* <section className="blog-wrap pt-100 pb-75">
            <div className="container">
              <div className="row">
                <div className="col-xl-6 offset-xl-3 col-lg-8 offset-lg-2">
                  <div className="section-title style1 text-center mb-40">
                    <span>OUR BLOG</span>
                    <h2>Keep Up To Date With Global Content From Our Trusted Team</h2>
                  </div>
                </div>
              </div>
              <div className="row justify-content-center">
                <div className="col-xl-4 col-lg-6 col-md-6" data-aos="fade-up" data-aos-duration="1000" data-aos-delay="200">
                  <div className="blog-card style1">
                    <div className="blog-img">
                      <img src="assets/img/blog/blog-1.jpg" alt="Image" />
                      <a href="posts-by-category.html" className="blog-cat">
                        Corporate
                      </a>
                    </div>
                    <div className="blog-info">
                      <ul className="blog-metainfo  list-style">
                        <li>
                          <i className="ri-calendar-2-line"></i>
                          <a href="posts-by-date.html">May 22, 2024</a>
                        </li>
                        <li>
                          <i className="ri-chat-3-line"></i>No Comment
                        </li>
                      </ul>
                      <h3>
                        <a href="blog-details-right-sidebar.html">How Exchange Rate Effect Your Business Growth</a>
                      </h3>
                    </div>
                  </div>
                </div>
                <div className="col-xl-4 col-lg-6 col-md-6" data-aos="fade-up" data-aos-duration="1000" data-aos-delay="300">
                  <div className="blog-card style1">
                    <div className="blog-img">
                      <img src="assets/img/blog/blog-2.jpg" alt="Image" />
                      <a href="posts-by-category.html" className="blog-cat">
                        Consumer
                      </a>
                    </div>
                    <div className="blog-info">
                      <ul className="blog-metainfo  list-style">
                        <li>
                          <i className="ri-calendar-2-line"></i>
                          <a href="posts-by-date.html">May 13, 2024</a>
                        </li>
                        <li>
                          <i className="ri-chat-3-line"></i>No Comment
                        </li>
                      </ul>
                      <h3>
                        <a href="blog-details-right-sidebar.html">How To Stop Currency From Being Overwhelmed</a>
                      </h3>
                    </div>
                  </div>
                </div>
                <div className="col-xl-4 col-lg-6 col-md-6" data-aos="fade-up" data-aos-duration="1000" data-aos-delay="400">
                  <div className="blog-card style1">
                    <div className="blog-img">
                      <img src="assets/img/blog/blog-3.jpg" alt="Image" />
                      <a href="posts-by-category.html" className="blog-cat">
                        Finance
                      </a>
                    </div>
                    <div className="blog-info">
                      <ul className="blog-metainfo  list-style">
                        <li>
                          <i className="ri-calendar-2-line"></i>
                          <a href="posts-by-date.html">Apr 15, 2024</a>
                        </li>
                        <li>
                          <i className="ri-chat-3-line"></i>No Comment
                        </li>
                      </ul>
                      <h3>
                        <a href="blog-details-right-sidebar.html">How To Transfer Money With International Debit Card</a>
                      </h3>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section> */}
        </div>
      </div>
    </>
  );
};

export default CurrencyConverterPage;
